import { render, staticRenderFns } from "./SinisterFilters.vue?vue&type=template&id=dda1fc4a&scoped=true"
import script from "./SinisterFilters.vue?vue&type=script&lang=ts"
export * from "./SinisterFilters.vue?vue&type=script&lang=ts"
import style0 from "./SinisterFilters.vue?vue&type=style&index=0&id=dda1fc4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dda1fc4a",
  null
  
)

export default component.exports